 $('.faqs div h3 button').on('click', function(event) {
   var elementParent = $(event.target).parents('div[data-state]');
   if (elementParent.attr('data-state') == 'closed') {
     elementParent.attr('data-state','open');
     elementParent.find('h3').attr('data-state','open');
     elementParent.find('button').attr('data-state','open');
     elementParent.find('> div').show();
   } else {
     elementParent.attr('data-state','closed');
     elementParent.find('h3').attr('data-state','closed');
     elementParent.find('button').attr('data-state','closed');
     elementParent.find('> div').hide();
   }
 });